module.exports = __webpack_public_path__ + "static2023-4-17/img/question.e73d146d.png";